import { baseCRUDAPI } from './base';

export default class PowerBI extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'PowerBI');
  }

  async embedToken(reportName) {
    const resp = await this.axiosObject.post(
      `${this.apiBaseName}/Embed_Token/${reportName}`,
    );

    return resp.data;
  }

  async outputVisual(reportName, pageName, visualName) {
    return this.axiosObject({
      method: 'POST',
      url: `${this.apiBaseName}/OutputVisual/report/${reportName}/page/${pageName}/visual/${visualName}`,
      responseType: 'blob',
    });
  }
}
